/**
 * Разделы лендинга markbase.ru — единый источник якорей и подписей.
 * Порядок массива = порядок секций в DOM (нужен scroll-spy боковой навигации).
 * Consumers: PublicHeader (isLanding) и LandingSideToc. Своих списков они не держат.
 */
export const LANDING_SECTIONS = [
  { id: 'ecosystem', label: 'Направления', inHeader: true, icon: 'Users' },
  { id: 'who', label: 'Кому подходит', inHeader: false, icon: 'Users' },
  { id: 'ai-flow', label: 'AI за вас', inHeader: true, icon: 'Sparkles' },
  { id: 'modules', label: 'Платформа', inHeader: true, icon: 'LayoutGrid' },
  { id: 'quickstart', label: 'С чего начать', inHeader: true, icon: 'ListChecks' },
  { id: 'data', label: 'Один каталог', inHeader: false, icon: 'Layers' },
  { id: 'cases', label: 'Кейсы', inHeader: true, icon: 'Store' },
  { id: 'pricing', label: 'Тарифы', inHeader: true, icon: 'Scale' },
  { id: 'faq', label: 'Вопросы', inHeader: true, icon: 'CircleHelp' },
  { id: 'contact-cta', label: 'Написать', inHeader: false, icon: 'Mail' },
];

/** Компактное меню шапки: только приоритетные разделы. */
export const LANDING_HEADER_SECTIONS = LANDING_SECTIONS.filter((section) => section.inHeader);

/** Пункты меню шапки в формате PublicHeader ({ key, label }). */
export const landingHeaderMenuItems = () =>
  LANDING_HEADER_SECTIONS.map((section) => ({ key: `#${section.id}`, label: section.label }));
